<template>
  <input
    ref="inputRef"
    :class="[
      $style.input,
      $style[size],
      {
        [$style.isDisabled]: disabled,
        [$style.hasError]: hasError
      }
    ]"
    type="text"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
    @onChange="$emit('change', $event)"
    :disabled="!!disabled"
    v-test="'_base-input-input'"
  >
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted, watch } from 'vue';
import { useCurrencyInput } from 'vue-currency-input';
import { useCompanyStore } from '@/stores/company';

export default defineComponent({
  inheritAttrs: false,
  props: {
    modelValue: Number,
    inputModeText: {
      Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'm',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change', 'blur', 'focus'],
  setup(props) {
    const { company, isUk } = useCompanyStore();

    const { inputRef, setValue } = useCurrencyInput({
      currency: company?.currency || 'EUR',
      locale: isUk ? 'en-GB' : 'nl',
      precision: 2,
      valueScaling: 'precision',
    });

    watch(
      () => props.modelValue,
      (value) => {
        setValue(value);
      },
    );

    onMounted(() => {
      nextTick(() => {
        if (props.inputModeText && inputRef.value) {
          inputRef.value.setAttribute('inputmode', 'text');
        }
      });
    });

    const onBlur = () => {
      // When clearing the input field, the value should be set to 0
      if (!inputRef.value.value) {
        setValue(0);
      }
    };

    return { inputRef, onBlur };
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  position: relative;
}

.input {
  @include input;

  &.hasError {
    border-color: var(--error-base) !important;

    &:focus {
      box-shadow: 0 0 0 4px var(--focus-ring-error);
    }
  }

  &.isDisabled {
    @include input-disabled;
  }

  .base.hasError & {
    border-color: var(--error-base) !important;
    padding-right: 30px;

    &:focus {
      box-shadow: 0 0 0 4px var(--focus-ring-error);
    }
  }

  .base.l & {
    font-size: 26px;
    height: 52px;
  }
}

.alertIcon {
  position: absolute;
  right: $spacing * 0.5;
  top: 0;
  bottom: 0;
  margin: auto;
  pointer-events: none;
  display: flex;
  align-items: center;
}
</style>
